import { RootState } from '../store';

export const imageUrlSelector = (state: RootState) => state.imageUrl;
